import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { I18nextProvider, useTranslation } from 'react-i18next';
import Pagination from './Pagination';


let i18nInstance = null;


const paginationInstances = new Map();

export const initAutoPagination = (i18n) => {
    i18nInstance = i18n;

    // Poslušajmo dogodke za uničenje tabele
    $(document).on('destroy.dt', function (e, settings) {
        const tableId = settings.nTable.id;
        if (tableId) {
            // Odstranimo paginacijo, ko se tabela uniči
            removePaginationForTable(tableId);
        }
    });

    // Poslušajmo dogodke za inicializacijo tabele
    $(document).on('init.dt', function (e, settings) {
        const tableId = settings.nTable.id;
        if (tableId) {
            // Odstranimo staro paginacijo, če obstaja
            removePaginationForTable(tableId);
            setTimeout(() => updatePaginationForTable(tableId), 100);
        }
    });

    // Poslušajmo dogodke za risanje tabele
    $(document).on('draw.dt', function (e, settings) {
        const tableId = settings.nTable.id;
        if (tableId) {
            updatePaginationForTable(tableId);
        }
    });

    // Poslušajmo dogodke za spremembo dolžine strani
    $(document).on('length.dt', function (e, settings) {
        const tableId = settings.nTable.id;
        if (tableId) {
            setTimeout(() => updatePaginationForTable(tableId), 50);
        }
    });

    // Posodobimo paginacijo za vse obstoječe tabele
    setTimeout(() => {
        $('.dataTable').each(function () {
            const tableId = $(this).attr('id');
            if (tableId && $.fn.DataTable.isDataTable(`#${tableId}`)) {
                updatePaginationForTable(tableId);
            }
        });
    }, 100);
};


const updatePaginationForTable = (tableId) => {
    // Najprej odstranimo staro paginacijo, če obstaja
    const existingContainer = document.querySelector(`.auto-pagination-wrapper[data-table-id="${tableId}"]`);
    if (existingContainer) {
        ReactDOM.unmountComponentAtNode(existingContainer);
        existingContainer.remove();
        paginationInstances.delete(tableId);
    }

    // Preverimo, ali tabela sploh obstaja v DOM-u
    const tableElement = document.getElementById(tableId);
    if (!tableElement) {
        // Če tabela ne obstaja v DOM-u, zagotovimo, da je paginacija odstranjena
        return;
    }

    // Preverimo, ali je tabela inicializirana kot DataTable
    if (!$.fn.DataTable.isDataTable(`#${tableId}`)) {
        // Če tabela ni inicializirana, odstranimo paginacijo
        return;
    }

    let pageInfo;
    try {
        const table = $(`#${tableId}`).DataTable();
        pageInfo = table.page.info();

        // Preverimo, ali je tabela prazna - če je, ne prikažemo paginacije
        if (!pageInfo ||
            pageInfo.recordsTotal === 0 ||
            pageInfo.recordsTotal === null ||
            pageInfo.recordsTotal === undefined ||
            pageInfo.pages === 0) {
            return;
        }
    } catch (error) {
        // Če pride do napake pri dostopu do tabele, odstranimo paginacijo
        console.warn(`Error accessing table ${tableId}:`, error);
        return;
    }

    const wrapper = $(tableElement).closest('.dataTables_wrapper');
    if (!wrapper.length) {
        return;
    }

    const paginationData = {
        currentPage: pageInfo.page + 1,
        pages: pageInfo.pages,
        startItem: pageInfo.start + 1,
        endItem: pageInfo.end,
        totalItems: pageInfo.recordsTotal,
        limit: pageInfo.length
    };

    // Ustvarimo nov container
    const container = document.createElement('div');
    container.className = 'auto-pagination-wrapper';
    container.setAttribute('data-table-id', tableId);
    wrapper.after(container);

    const handlePaginationChange = (e, pageIndex) => {
        if (!$.fn.DataTable.isDataTable(`#${tableId}`)) {
            return;
        }

        const table = $(`#${tableId}`).DataTable();

        if (e.target.name === "listDisplayElements") {
            const newLimit = parseInt(e.target.value);
            table.page.len(newLimit).draw();

            const lsData = JSON.parse(localStorage.getItem('E-DRAZBE.filterDisplay') || '{}');
            if (lsData.pagination) {
                lsData.pagination.limit = newLimit;
                localStorage.setItem('E-DRAZBE.filterDisplay', JSON.stringify(lsData));
            }
        } else {
            table.page(pageIndex - 1).draw('page');
        }
    };

    const PaginationWithI18n = () => {
        const { t } = useTranslation();
        return (
            <Pagination
                paginationData={paginationData}
                onPaginationChange={handlePaginationChange}
                t={t}
            />
        );
    };

    ReactDOM.render(
        <I18nextProvider i18n={i18nInstance}>
            <PaginationWithI18n />
        </I18nextProvider>,
        container
    );

    paginationInstances.set(tableId, container);
};


const removePaginationForTable = (tableId) => {
    const container = paginationInstances.get(tableId);
    if (container) {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
        paginationInstances.delete(tableId);
    }
};


export const cleanupAutoPagination = () => {
    paginationInstances.forEach((container, tableId) => {
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
    });
    paginationInstances.clear();

    $(document).off('destroy.dt');
    $(document).off('init.dt');
    $(document).off('draw.dt');
    $(document).off('length.dt');
};

